// extracted by mini-css-extract-plugin
export default {"whatsapp":"whatsApp_whatsapp__nvP3K"};